import { render, staticRenderFns } from "./update-prod.vue?vue&type=template&id=55e83585&scoped=true"
import script from "./update-prod.vue?vue&type=script&lang=js"
export * from "./update-prod.vue?vue&type=script&lang=js"
import style0 from "./update-prod.vue?vue&type=style&index=0&id=55e83585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e83585",
  null
  
)

export default component.exports